/**
 * Centralized environment variables.
 * Import from `@/common/config` — never read `import.meta.env` directly elsewhere.
 */
export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  appEnv: import.meta.env.VITE_APP_ENV ?? 'development',
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
  photoBaseUrl: import.meta.env.VITE_PHOTO_BASE_URL ?? '',
  oneSignalAppId: import.meta.env.VITE_ONESIGNAL_APP_ID ?? '',
  oneSignalSafariWebId: import.meta.env.VITE_ONESIGNAL_SAFARI_WEB_ID ?? '',
};
